module.exports = __webpack_public_path__ + "img/79578.39ea28b3.jpg";